import {
  IosArrowHorizontalScroller,
  IosClose,
  Trash,
} from '@sgcmpteltd/uikit-react';

import {
  AD_FEATURE_TABS_SCROLL_END_TOLERANCE,
  LABEL_CLOSE_ICON_SIZE,
  LABEL_REMOVE_ALL_ICON_SIZE,
} from './constants';
import styles from './styles.module.scss';
import type { Component, FilterValue } from './types';
import {
  isFilterCheckbox,
  isFilterChoice,
  isFilterRange,
  isFilterSelect,
} from './utils';

export const FilterLabelList: Component = ({
  values,
  hasRemoveAll,
  onRemove,
  onRemoveAll,
  hasMargin,
}) => {
  const handleRemove = (value: FilterValue, index: number) => () => {
    onRemove?.(index, value);
  };

  const handleRemoveAll = () => {
    onRemoveAll?.();
  };

  return (
    <div className={styles.containerRoot}>
      {hasRemoveAll && (
        <span
          className={styles.containerRemoveAll}>
          <button
            aria-label="remove-all"
            className={styles.imageButton}
            type="button"
            onClick={handleRemoveAll}>
            <Trash size={LABEL_REMOVE_ALL_ICON_SIZE} />
          </button>
        </span>
      )}
      <div className={`${styles.labels} ${hasMargin ? styles.hasMargin : ''}`}>
        <IosArrowHorizontalScroller
          scrollDistance={({ clientWidth }) => clientWidth}
          scrollEndTolerance={AD_FEATURE_TABS_SCROLL_END_TOLERANCE}>
          <div className={styles.containerLabels}>
            {values.map((value, index) => {
              if (isFilterCheckbox(value)) {
                const { name, checkboxName, checkboxValue } = value;
                return checkboxName && (
                  <div
                    key={`${name}-${checkboxName}-${checkboxValue}`}
                    className={styles.containerLabel}>
                    <span className={styles.textLabel}>
                      {checkboxName}
                    </span>
                    <button
                      aria-label="remove"
                      className={styles.iconClose}
                      type="button"
                      onClick={handleRemove(value, index)}>
                      <IosClose size={LABEL_CLOSE_ICON_SIZE} />
                    </button>
                  </div>
                );
              }

              if (isFilterChoice(value)) {
                const {
                  name, optionValue, inputValue, unit,
                } = value;

                return (
                  <span
                    key={`${name}-${optionValue.text}-${inputValue}`}
                    className={styles.containerLabel}>
                    <span className={styles.textLabel}>
                      {`${name} ${optionValue.text} ${unit?.type === 'prefix' ? unit.value : ''}${inputValue} ${unit?.type === 'suffix' ? unit.value : ''}`}
                    </span>
                    <button
                      aria-label="remove"
                      className={styles.iconClose}
                      type="button"
                      onClick={handleRemove(value, index)}>
                      <IosClose size={LABEL_CLOSE_ICON_SIZE} />
                    </button>
                  </span>
                );
              }

              if (isFilterRange(value)) {
                let label: string;

                const {
                  name, lowerValue, upperValue,
                } = value;

                if (lowerValue.value && !upperValue.value) {
                  label = `more than ${lowerValue.text}`;
                } else if (!lowerValue.value && upperValue.value) {
                  label = `less than ${upperValue.text}`;
                } else {
                  label = `${lowerValue.text} to ${upperValue.text}`;
                }

                return (
                  <span
                    key={`${name}-${lowerValue.value}-${upperValue.value}`}
                    className={styles.containerLabel}>
                    <span className={styles.textLabel}>
                      {`${name} ${label}`}
                    </span>
                    <button
                      aria-label="remove"
                      className={styles.iconClose}
                      type="button"
                      onClick={handleRemove(value, index)}>
                      <IosClose size={LABEL_CLOSE_ICON_SIZE} />
                    </button>
                  </span>
                );
              }

              if (isFilterSelect(value)) {
                const {
                  name, optionValue,
                } = value;

                return (
                  <span
                    key={`${name}-${optionValue}`}
                    className={styles.containerLabel}>
                    <span className={styles.textLabel}>
                      {optionValue.text}
                    </span>
                    <button
                      aria-label="remove"
                      className={styles.iconClose}
                      type="button"
                      onClick={handleRemove(value, index)}>
                      <IosClose size={LABEL_CLOSE_ICON_SIZE} />
                    </button>
                  </span>
                );
              }
              return null;
            })}
          </div>
        </IosArrowHorizontalScroller>
      </div>
    </div>
  );
};
